'use client';

import {
    Alert,
    AlertState,
    Box,
    BoxContent,
    Button,
    Columns,
    ColumnsItem,
    Image,
    Price,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

import { useHome } from '@landing/hooks';

interface BboxOtisOptionProps {
    onClick: () => void;
    onAddOtisRepeater: () => void;
    shouldShowAlert: boolean;
    repeaterPrice: number;
}

export default function BboxOtisOption({
    onClick,
    onAddOtisRepeater,
    shouldShowAlert,
    repeaterPrice,
}: Readonly<BboxOtisOptionProps>) {
    const { selectedFaiOption } = useHome();

    return (
        <View className='option-otis'>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                En option&nbsp;:&nbsp;le WiFi à tous les étages
            </Text>
            <Alert
                alert={AlertState.WARNING}
                display={shouldShowAlert}
                title="Ajoutez d'abord l'offre Pure Fibre"
                description="L'option répéteur WiFi est seulement compatible avec l'offre Pure Fibre. Ajoutez-la pour continuer !"
            />

            <Box className='custom-box'>
                <BoxContent background={TrilogyColor.SECONDARY20} className='is-paddingless'>
                    <Columns mobile centered verticalCentered className='is-gapless'>
                        <ColumnsItem narrow className='box-img-container'>
                            <Image
                                src='https://bouyguestelecom.fr/assets/media/full/image/CMS/ecommerce/byou/Repeteur.webp'
                                alt='Box'
                                width={80}
                                height={100}
                            />
                        </ColumnsItem>

                        <ColumnsItem className='has-background-white'>
                            <View className='has-custom-padding has-text-tertiary-60'>
                                <Columns verticalCentered className=''>
                                    <ColumnsItem>
                                        <Columns mobile marginless verticalCentered className='gap-medium'>
                                            <ColumnsItem className='is-paddingless' narrow>
                                                <Text
                                                    marginless
                                                    typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                                    level={TextLevels.ONE}
                                                >
                                                    Répéteur&nbsp;WiFi 7
                                                </Text>
                                            </ColumnsItem>
                                            <ColumnsItem narrow className='is-paddingless'>
                                                <Text level={TextLevels.TWO} markup={TextMarkup.SPAN}>
                                                    &nbsp;+
                                                    <Price
                                                        className='normal-weight'
                                                        amount={repeaterPrice}
                                                        inline
                                                        period='mois'
                                                    />
                                                </Text>
                                            </ColumnsItem>
                                        </Columns>
                                        <Text marginless level={TextLevels.TWO}>
                                            Idéal pour les logements de plus de 80 m²
                                        </Text>
                                        <a onClick={onClick} className='button-clear link has-text-blue-byou'>
                                            Ai-je besoin d&lsquo;un répéteur&nbsp;?
                                        </a>
                                    </ColumnsItem>
                                    <ColumnsItem narrow>
                                        <Button
                                            variant={selectedFaiOption ? TrilogyColor.TERTIARY : TrilogyColor.PRIMARY}
                                            className={`is-block ${selectedFaiOption ? '' : 'has-byou-background'}`}
                                            onClick={onAddOtisRepeater}
                                        >
                                            {selectedFaiOption ? 'Retirer du panier' : 'Ajouter au panier'}
                                        </Button>
                                    </ColumnsItem>
                                </Columns>
                            </View>
                        </ColumnsItem>
                    </Columns>
                </BoxContent>
            </Box>
        </View>
    );
}
